import React, { FC } from 'react';
import keys from 'weak-key';
import styles from './PackageDescriptions.module.scss';

export interface PackageDescriptionsProps {
  blocks?: PackageDescriptionProps[];
}

interface PackageDescriptionProps {
  title: string;
  description: string;
  options: string[];
}

const PackageDescriptions: FC<PackageDescriptionsProps> = ({ blocks }: PackageDescriptionsProps) => (
  <div>
    {!!blocks && blocks.map((block) => {
      const { title, description, options } = block;

      return (
        <div key={keys(block)} className={styles.container}>
          <div className={styles.title}>
            {title}
          </div>
          <div className={styles.description}>
            {description}
          </div>
          {!!options?.length && (
            <ul className={styles.list}>
              {options.map((option) => (
                <li key={keys({ option })}>
                  {option}
                </li>
              ))}
            </ul>
          )}
        </div>
      );
    })}
  </div>
);

export default PackageDescriptions;
